import "./default-menu-dialog.css";

const DefaultComponent = ({ dataMap, onClose, onSuccess }) => {
  const itemList = Object.entries(dataMap).map(([key, label]) => ({
    key,
    label,
  }));

  const handleSelect = (key) => {
    onSuccess(key);
    onClose();
  };

  return (
    <div className="menu-dialog-outer">
      {itemList.map((item) => (
        <div
          key={item.key}
          className="menu-item"
          onClick={() => handleSelect(item.key)}
        >
          {item.label}
        </div>
      ))}
    </div>
  );
};

export default DefaultComponent;
